import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import "@css/pages/employer/DocumentsEmployers/courseCertifications.css";
import "@css/pages/employer/listeEmployer.css";

import EmptyData from "@components/tailwindComponents/EmptyData";

import CareerItem from "./CareerItem/index";
import { ModalCourseForm, ModalDeleteCourse } from "./modals";

const CareerList = ({
  careerList,
  deviceList,
  readOnly,
  removePost,
  hiringDate,
  employeeId,
  employeePoste = null
}) => {
  const { t } = useTranslation("pages.employés.parcours&Certifications");
  const [modalEditParcours, setModalEditParcours] = useState(false);
  const [modalDeleteParcours, setModalDeleteParcours] = useState(false);
  const [selectedCareer, setSelectedCareer] = useState(null);
  const [selectedCareerId, setSelectedCareerId] = useState("");

  const toggleEditParcours = (selectedCareer) => {
    setModalEditParcours(!modalEditParcours);
    setSelectedCareer(selectedCareer?._id ? selectedCareer : null);
  };

  const toggleDeleteParcours = (selectedCareer) => {
    setModalDeleteParcours(!modalDeleteParcours);
    setSelectedCareerId(selectedCareer?._id || "");
  };

  if (!careerList?.length) {
    return (
      <tr>
        <td colSpan={8}>
          <EmptyData>
            {t("Aucun parcours professionnel pour cet employé")}
          </EmptyData>
        </td>
      </tr>
    );
  }

  return (
    <>
      {careerList?.map((career, index) => (
        <CareerItem
          key={career._id}
          career={career}
          readOnly={readOnly}
          employeeId={career.employeeId}
          employeePoste={employeePoste}
          careerList={careerList}
          onDelete={() => toggleDeleteParcours(career)}
          onEdit={() => toggleEditParcours(career)}
        />
      ))}

      <ModalCourseForm
        career={selectedCareer}
        isOpen={modalEditParcours}
        toggle={toggleEditParcours}
        onClickClose={toggleEditParcours}
        removePost={removePost}
        hiringDate={hiringDate}
      />

      <ModalDeleteCourse
        idParcours={selectedCareerId}
        isOpen={modalDeleteParcours}
        toggle={toggleDeleteParcours}
        onClickClose={toggleDeleteParcours}
      />
    </>
  );
};

export default CareerList;
